<mat-list-item *ngIf="mostraModulo(infoMenu)" (click)="showSubmenu = !showSubmenu; routePrincipal(infoMenu)" class="parent">
    <p style="font-size: 14px;" mat-line>{{infoMenu.nome}}</p>
    <mat-icon mat-list-icon>{{infoMenu.icone}}</mat-icon>
    <mat-icon class="menu-button" [ngClass]="{'rotated' : showSubmenu}" *ngIf="infoMenu.submenu">expand_more</mat-icon>
</mat-list-item>

<div class="submenu" [ngClass]="{'expanded' : showSubmenu}" *ngIf="showSubmenu">
    <a style="font-size: 14px;" *ngFor="let submenu of infoMenu.submenu" routerLink={{submenu.link}} mat-list-item>{{submenu.nome}}</a>
</div>
